import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationHttpClient } from '@app/core/http';
import { AuthenticationService } from './authentication.service';

// import { City } from '@app/core/models';

@Injectable({ providedIn: 'root' })
export class BankService {
  constructor(
    private http: ApplicationHttpClient,
    private authService: AuthenticationService
  ) {}

  public getBanks(): Observable<any> {
    return this.http.get('/api/app/bank');
  }

  public getDetailByName(name: string) {
    return this.http.get(`/api/app/bank/detail?name=${name}`);
  }

  public filterBank(filters = {}) {
    return this.http.getList('/api/app/bank', {
      params: {
        ...filters
      }
    }).pipe(
      map(categories => {
        return categories.items.map(category => ({
          ...category,
          name: category.id + ' - ' + category.name,
          shortName: category.name
        }));
      })
    );
  }

  public filterBankNotDisplayCode(filters = {}) {
    return this.http.getList('/api/app/bank', {
      params: {
        ...filters
      }
    }).pipe(
      map(categories => {
        return categories.items.map(category => ({
          ...category,
          shortName: category.name
        }));
      })
    );
  }

  public downloadImportTemplate() {
    return this.http.getFile(`/api/app/bank/download-template`, {
      headers: {
        token: this.authService.getCredentialToken()
      }
    });
  }
}
